/** Join class names, dropping falsy entries. */
export function cx(...parts: Array<string | false | undefined | null>) {
  return parts.filter(Boolean).join(' ');
}
